"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceTypeEnum;
(function (ServiceTypeEnum) {
    ServiceTypeEnum["JOB"] = "job";
    ServiceTypeEnum["CLIENTS"] = "clients";
})(ServiceTypeEnum = exports.ServiceTypeEnum || (exports.ServiceTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZS10eXBlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvc2VydmljZS10eXBlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLGVBR1g7QUFIRCxXQUFZLGVBQWU7SUFDekIsOEJBQVcsQ0FBQTtJQUNYLHNDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFIVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQUcxQiJ9